import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import Api from 'services/Api'
import BaseModal from 'components/Modals/BaseModal'
import { Button } from 'components/Forms'
import { closeModal } from 'store/actions/modals'
import { Trans } from 'react-i18next'

import { Format } from 'services/Dates'
import { getAttributeName, getUserName } from 'services/Utilities'
import { Loading } from 'components/UI'
import { Badge, Card, List } from 'ui'

import { t } from 'translations'

const UserAttributesRemindersHistoryModal = ({ userId }) => {
  const dispatch = useDispatch()
  const { defaultTimeZone } = useSelector(state => state.settings)

  // const userInfo = usersById[userId]
  const [contactEvents, setContactEvents] = useState()
  useEffect(() => {
    const loadContactEvents = async () => {
      const { result, success } = await Api.get(`attributes/contact/events`, { params: { id: userId } })
      if (!success) return setContactEvents([])

      setContactEvents(result)
    }
    loadContactEvents()
  }, [userId])

  const getStyling = eventKey => {
    switch (eventKey) {
      case 'confirmed':
        return ['check-square', '']
      case 'delivered':
        return ['envelope', '']
      default:
        return ['', '']
    }
  }

  return (
    <BaseModal hideButtons title="manager.users.ATTRIBUTE_EXPIRATION_REMINDERS_MODAL" titleVar={{ name: getUserName(userId) }}>
      <List className=" mt-3">
        {!contactEvents && <Loading />}
        {!contactEvents?.length && (
          <Card className="mt-2">
            <Card.Body>{t(`manager.users.ATTRIBUTE_EXPIRATION_REMINDERS_MODAL.NO_REMINDERS`)}</Card.Body>
          </Card>
        )}

        {contactEvents?.reverse().map(({ _id, attributeId, events, userId }) => {
          const eventKeys = Object.keys(events)
          return (
            <List.Item className="d-flex justify-content-between" key={_id}>
              <div>
                {eventKeys.map((eventKey, index) => {
                  const [icon, className] = getStyling(eventKey)
                  return (
                    <div key={index} className={className}>
                      {icon !== '' ? <i className={`fad fa-${icon} mr-1`}></i> : null}
                      <Trans t={t} i18nKey={`manager.users.ATTRIBUTE_EXPIRATION_REMINDERS_MODAL.${eventKey.toUpperCase()}`}>
                        <b>{{ name: getUserName(userId) }}</b>
                        <b>{{ attribute: getAttributeName(attributeId) }}</b>
                        <b>{{ time: Format(events[eventKey], { outFormat: 'time', isUTC: true, timeZone: defaultTimeZone }) }}</b>
                        {{ date: Format(events[eventKey], { outFormat: 'humanDate', isUTC: true, timeZone: defaultTimeZone }) }}
                      </Trans>
                    </div>
                  )
                })}
              </div>
              <div>
                <Badge pill variant={events.confirmed ? 'success' : 'warning'}>
                  {t(`manager.users.ATTRIBUTE_EXPIRATION_REMINDERS_MODAL.${events.confirmed ? 'EVENT_CONFIRMED' : 'EVENT_DELIVERED'}`)}
                </Badge>
              </div>
            </List.Item>
          )
        })}
      </List>
      <div className="mt-3">
        <Button text="actions.CLOSE" className="btn btn-outline-secondary" onClick={() => dispatch(closeModal())} />
      </div>
    </BaseModal>
  )
}

export default UserAttributesRemindersHistoryModal
